import { Org, PortalSettingsAccessConsole, PortalSettingsAccessPortal } from '@nx-frontend/shared/types';

interface HasAccessProps {
  isCustomizer: boolean;
  access: PortalSettingsAccessConsole | PortalSettingsAccessPortal;
  org: Org;
  userId: number;
  portalUrl: string;
  magicLinks: {
    id: string;
    url: string;
  }[];
  orgRole?: string;
  workspaceRole?: string;
}

export function hasAccess({
  isCustomizer,
  access,
  org,
  userId,
  magicLinks,
  portalUrl,
  orgRole,
  workspaceRole,
}: HasAccessProps): boolean {
  const magicLinkAccess =
    !isCustomizer &&
    !!magicLinks?.find((magicLink) => {
      return magicLink.url === portalUrl;
    });

  if (magicLinkAccess) {
    return true;
  }

  if ('anyone' in access && access.anyone) {
    return true;
  }

  if ((!('anyone' in access) || ('anyone' in access && !access.anyone)) && !workspaceRole) {
    return false;
  }

  if ('clients' in access && access.clients && orgRole === 'client') {
    return true;
  }

  if (access.owner && org.userId === userId) {
    return true;
  }

  if (access.guests && orgRole === 'guest') {
    return true;
  }

  if (access.managers && orgRole === 'manager') {
    return true;
  }

  if (access.members && orgRole === 'member') {
    return true;
  }

  return false;
}
